import { render, staticRenderFns } from "./QuayDockEdit.vue?vue&type=template&id=18965a5a&scoped=true"
import script from "./QuayDockEdit.vue?vue&type=script&lang=js"
export * from "./QuayDockEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18965a5a",
  null
  
)

export default component.exports